<template>
  <div class="gf_price-compare">
    <div class="gf_price-compare__sticky" v-if="isFixedNav">
      <div class="gf_price-compare__section gf_pricing__container" :class="{'gf_price-compare__section--trial': isTableCol4}">
        <div class="gf_price-compare__box__plan gf_price-compare__box__plan__sticky">
          <div class="gf_pricing__switch">
            <div class="gf_pricing__switch--month" :class="{'mode-disabled': yearlyMode}">{{ $t('downgrade.confirm.choosedPlan.billingInterval.monthly') }}</div>
            <div class="gf_pricing__switch--toggle">
              <Switcher
                v-model="yearlyMode"
                :padding="'p-0 m-0'"
                :classToggler="'p-0 m-0'"
                @input="setYearlyMode(yearlyMode)"
              >
              </Switcher>
            </div>
            <div class="gf_pricing__switch--year" :class="{'mode-disabled': !yearlyMode}">{{ $t('downgrade.confirm.choosedPlan.billingInterval.yearly') }}</div>
            <div class="gf_pricing__switch--sale">({{ $t('generals.save') }} 20%)</div>
          </div>
        </div>
        <Item
          v-for="(content, key) in dynamicContent.plans"
          :content="content"
          :key="key"
          :yearly-mode="isYearly"
          :isRecommended="recommended === key"
          :planNo="key" />
      </div>
    </div>
    <div class="gf_compare__plan gf_pricing__container" v-if="isShowTablePricing">
      <template v-for="(group, groupIndex) in dataPlan.compare">
        <div class="gf_plan__group" :key="groupIndex">
          <div class="gf_plan__group-text">
            {{ $t(group.title) }}
          </div>
          <template v-for="(option, optionIndex) in group.options">
            <div v-if="isDisplayOptionsByConditions(option.display_conditions)" class="gf_plan__option" :key="optionIndex">
              <div class="gf_price-compare__section gf_pricing__container" :class="{'gf_price-compare__section--trial': isTableCol4}">
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--title" :class="{'gf_price-compare__box__plan--trial': isTableCol4}">
                  {{ $t(option.title) }} <BetaTag v-if="option.isBeta" /> <NewTag v-if="option.isNew" />
                  <div class="gf_price-intro__item--tooltip" v-if="option.tooltip">
                    <PricingTooltips
                      type="default"
                      :image="option.tooltip.image"
                      :title="option.tooltip.title"
                      :description="option.tooltip.desc" />
                  </div>
                  </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.trial.desc}" v-if="option.trial && isFreeTrial">
                    <template v-if="option.trial.title">
                      <span v-html="$t(option.trial.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.trial.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.trial.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.trial.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.trial2022.desc}" v-if="option.trial2022 && isFreeTrial2022">
                    <template v-if="option.trial2022.title">
                      <span v-html="$t(option.trial2022.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.trial2022.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.trial2022.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.trial2022.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.development.desc}" v-if="option.development && isDevelopment">
                    <template v-if="option.development.title">
                      <span v-html="$t(option.development.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.development.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.development.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.development.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.development2022.desc}" v-else-if="option.development2022 && (isDevelopment2022 || isDevelopment)">
                  <template v-if="option.development2022.yearly && yearlyMode && !isDevelopment">
                    <template v-if="option.development2022.yearly.title">
                      <span v-html="$t(option.development2022.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.development2022.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>
                  <template v-else-if="option.development2022.title">
                    <span v-html="$t(option.development2022.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.development2022.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.development2022.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.development2022.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.starter.desc}" v-if="option.starter && isStarter">
                    <template v-if="option.starter.title">
                      <span v-html="$t(option.starter.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.starter.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                    <template v-if="option.starter.desc" >
                      <div class="gf_plan__option__item__desc-list">
                        <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.starter.desc" :key="index">
                          <img v-if="item.status" src="../../assets/status-check.svg">
                          <img v-else src="../../assets/status-false.svg">
                          <span v-html="$t(item.title)"></span>
                          <UpcomingTag v-if="item.isUpcoming" />
                        </div>
                      </div>
                    </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.professional.desc}" v-if="option.professional && currentPlanProfessional && !isDevelopment">
                  <template v-if="option.professional.yearly && yearlyMode">
                    <template v-if="option.professional.yearly.title">
                      <span v-html="$t(option.professional.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.professional.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>  
                  <template v-else-if="option.professional.title">
                    <span v-html="$t(option.professional.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.professional.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.professional.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.professional.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.build.desc}" v-else-if="option.build">
                  <template v-if="option.build.yearly && yearlyMode && !currentPlanProfessional">
                    <template v-if="option.build.yearly.title">
                      <span v-html="$t(option.build.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.build.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>
                  <template v-else-if="option.build.title">
                    <span v-html="$t(option.build.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.build.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.build.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.build.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4, 'gf_plan__option__item__desc': option.optimize.desc}" v-if="option.optimize">
                  <template v-if="(option.optimize.planOld && isAdvancePlan)">
                    <template v-if="option.optimize.planOld.title">
                      <span v-html="$t(option.optimize.planOld.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.optimize.planOld.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>   
                  <template v-else-if="(option.optimize.yearly && yearlyMode)">
                    <template v-if="option.optimize.yearly.title">
                      <span v-html="$t(option.optimize.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.optimize.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>   
                  <template v-else-if="option.optimize.title">
                    <span v-html="$t(option.optimize.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.optimize.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                  <template v-if="option.optimize.desc" >
                    <div class="gf_plan__option__item__desc-list">
                      <div class="gf_plan__option__item__desc-item" v-for="(item, index) in option.optimize.desc" :key="index">
                        <img v-if="item.status" src="../../assets/status-check.svg">
                        <img v-else src="../../assets/status-false.svg">
                        <span v-html="$t(item.title)"></span>
                        <UpcomingTag v-if="item.isUpcoming" />
                      </div>
                    </div>
                  </template>
                </div>
                <div class="gf_price-compare__box__plan gf_plan__option__item gf_plan__option--status" :class="{'gf_price-compare__box__plan--trial': isTableCol4}" v-if="option.enterprise">
                  <template v-if="option.enterprise.yearly && yearlyMode">
                    <template v-if="option.enterprise.yearly.title">
                      <span v-html="$t(option.enterprise.title)"></span>
                    </template>
                    <template v-else>
                      <img v-if="option.enterprise.yearly.status" src="../../assets/status-check.svg">
                      <img v-else src="../../assets/status-false.svg">
                    </template>
                  </template>    
                  <template v-else-if="option.enterprise.title">
                    <span v-html="$t(option.enterprise.title)"></span>
                  </template>
                  <template v-else>
                    <img v-if="option.enterprise.status" src="../../assets/status-check.svg">
                    <img v-else src="../../assets/status-false.svg">
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Switcher from "@/core/shared/essenstials/Switcher.vue";
import Item from "@/modules/Pricing/components/PricingPlanCompare/Item";
import plan from "@/modules/Pricing/mixins/plan";
import PricingTooltips from "@/modules/Pricing/components/PricingTooltips";
import { PLAN_NO } from "@/contants/plan";
import BetaTag from "./BetaTag.vue"
import NewTag from "./NewTag.vue"
import UpcomingTag from "./UpcomingTag.vue";

export default {
  name: "TablePricing",
  components: {
    Switcher,
    Item,
    PricingTooltips,
    BetaTag,
    NewTag,
    UpcomingTag
},
  mixins: [plan()],
  props: {
    dataPlan: {
      type: Object || Array,
      default: () => [],
    },
    currentPlan: {
      type: String,
    },
    isShowTablePricing: {
      default: false,
    },
  },
  data() {
    return {
      isFixedNav: false,
      yearlyMode: false
    }
  },
  computed: {
    isAdvancePlan() {
      return this.plan === PLAN_NO.ADVANCED;
    },
  },
  watch: {
    yearlyMode(value) {
      this.$eventBus.$emit('switch-yearly-mode-compare', value);
    }
  },
  mounted() {
    this.handleScroll();
    this.$eventBus.$off('switch-yearly-mode')
    this.$eventBus.$on('switch-yearly-mode', (mode) => {
      this.yearlyMode = mode
    });
  },
  methods: {
    handleScroll() {
      const body = document.getElementById("gfPricing");
      if (body) {
        body.onscroll = () => {
          const elementOffset = document.getElementById("gfPricingTable").offsetTop;
          const scrollY = body.scrollTop;
          if (scrollY > (elementOffset - 150)) {
            this.$nextTick(() => {
              this.isFixedNav = true;
            })
          } else {
            this.$nextTick(() => {
              this.isFixedNav = false;
            })
          }
        };
      }
    },
    isDisplayOptionsByConditions(conditions){
    if(!conditions){
      return true;
    }
    const {gem_versions} = conditions;
    return gem_versions.includes(this.gemVersion);
  }
  },
  
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>
